import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, ViewController, ModalController } from 'ionic-angular';
import { AbstractPage } from '../../_com/abstract-page';
import { ReserveEditPage } from '../edit/reserve-edit';
import { CompReserveListState } from '../../../states/comp-reserve-list-state';
import Utils from '../../../_com/utils';

/**
 * Generated class for the ReserveListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reserve-list',
  templateUrl: 'reserve-list.html',
})
export class ReserveListPage extends AbstractPage{

  listType = "basic";
  data = {
    date : null
  };

  @ViewChild(Content) content: Content;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public viewController:ViewController,
    private compReserveListState:CompReserveListState,
    private modalController:ModalController,
   ) {
    super();

    /**
     * 日付変更確定イベント
     */
    this.mbscDateOptions["onSet"] = ((event, inst) => {
      this.triggerDateChange();
    });
  }

  /**
   * 詳細画面からの戻り時に再検索を発火する
   */
  ionViewDidEnter() {
    this.triggerDateChange();
  }

  /**
   * 日付移動
   */
  dayMove(adjust){
    this.data.date = Utils.date.calcDate(this.data.date, adjust);
    this.triggerDateChange();
  }

  /**
   * 予約追加
   */
  openReserveEdit(){

    var data = {date:this.data.date};
    let modal = this.modalController.create(ReserveEditPage, data, {enableBackdropDismiss:false});
    modal.present();
  }

  ionViewDidLoad() {
    this.data.date = this.compReserveListState.date;
  }

  dismiss(){
    this.viewController.dismiss();
  }

  /**
   * 日付変更をStateに通知する
   */
  triggerDateChange(){
    this.compReserveListState.date = this.data.date;
  }
}


// WEBPACK FOOTER //
// ./src/pages/reserve/list/reserve-list.ts